var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.235 61.9788C111.505 61.9788 106.696 65.4589 103.642 69.6956C100.59 65.4589 95.7783 61.9788 90.0481 61.9788C80.9147 61.9788 73.6156 69.0952 72.6614 78.9136C72.561 79.5597 72.3146 81.8486 73.1995 85.4224C74.5029 90.6991 77.5043 95.4882 81.8833 99.283L101.803 116.398C102.336 116.857 102.989 117.087 103.644 117.087C104.295 117.087 104.948 116.859 105.481 116.403L125.405 99.2782C129.779 95.493 132.781 90.7039 134.086 85.4248C134.969 81.8486 134.725 79.5621 134.624 78.916C133.67 69.0952 126.371 61.9788 117.235 61.9788ZM129.442 84.2671C128.378 88.5759 125.902 92.5076 122.289 95.6323L103.644 111.657L85.0019 95.6371C81.381 92.5028 78.9058 88.5735 77.8439 84.2647C77.1217 81.3514 77.3824 79.711 77.38 79.711L77.4206 79.4564C78.0042 73.1614 82.5314 66.7871 90.0505 66.7871C95.2856 66.7871 99.5545 71.1367 101.458 75.4455L103.644 80.3955L105.83 75.4455C107.734 71.1343 112 66.7871 117.238 66.7871C124.762 66.7871 129.286 73.1614 129.904 79.6798C129.904 79.6918 130.167 81.3346 129.442 84.2671Z",
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.088 33.0038C113.088 27.792 108.867 23.5505 103.677 23.5505C98.4872 23.5505 94.2637 27.792 94.2637 33.0038C94.2637 38.2156 98.4872 42.4548 103.677 42.4548C108.867 42.4548 113.088 38.2156 113.088 33.0038ZM99.0492 33.0038C99.0492 30.4411 101.125 28.354 103.679 28.354C106.229 28.354 108.307 30.4387 108.307 33.0038C108.307 35.5641 106.231 37.6512 103.679 37.6512C101.125 37.6488 99.0492 35.5641 99.0492 33.0038Z",
    fill: "url(#paint2_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.541 1.93463H77.0496L16.543 62.4999L16.5645 62.5192L2.20557 76.9009L62.3128 137.394L80.7613 119.652L23.347 62.5095L79.025 6.73816H108.566L132.34 30.5613V61.5344H137.123V28.5678L110.541 1.93463ZM73.9071 119.592L62.3869 130.672L8.96891 76.9105L19.9605 65.9008L73.9071 119.592Z",
    fill: "#5C6B73",
    stroke: "#5C6B73",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 72.5522,
    y1: 89.533,
    x2: 131.512,
    y2: 122.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 72.5522,
    y1: 89.533,
    x2: 131.512,
    y2: 122.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 94.2637,
    y1: 33.0026,
    x2: 113.12,
    y2: 42.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6661"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.ecfff2a91169317b794ea3b87c158c62.svg";
export { ForwardRef as ReactComponent };